import React, {
  useEffect,
  useState,
} from "react";

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap";

import {
  FiUser,
  FiSettings,
  FiUsers,
  FiList,
  FiFileText,
  FiActivity,
  FiLogOut,
  FiChevronRight,
  FiLock,
  FiEye,
  FiEyeOff,
} from "react-icons/fi";

import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import axios from "../../utills/api";


const ProfileDropdown = () => {

  const [
    isProfileDropdown,
    setIsProfileDropdown,
  ] = useState(false);

  const [
    user,
    setUser,
  ] = useState(null);




  const [
    isPasswordModalOpen,
    setIsPasswordModalOpen,
  ] = useState(false);

  const [
    currentPassword,
    setCurrentPassword,
  ] = useState("");

  const [
    newPassword,
    setNewPassword,
  ] = useState("");

  const [
    confirmPassword,
    setConfirmPassword,
  ] = useState("");

  const [
    showCurrentPassword,
    setShowCurrentPassword,
  ] = useState(false);

  const [
    showNewPassword,
    setShowNewPassword,
  ] = useState(false);

  const [
    showConfirmPassword,
    setShowConfirmPassword,
  ] = useState(false);

  const [
    isChangingPassword,
    setIsChangingPassword,
  ] = useState(false);

  const [
    passwordError,
    setPasswordError,
  ] = useState("");

  const [
    passwordSuccess,
    setPasswordSuccess,
  ] = useState("");


  /* =========================================================
     LOAD AUTHENTICATED USER
  ========================================================= */

  useEffect(() => {

    const storedUser =
      localStorage.getItem("user");

    const storedAuthUser =
      localStorage.getItem("authUser") ||
      sessionStorage.getItem("authUser");

    try {

      if (storedUser) {

        const parsedUser =
          JSON.parse(storedUser);

        setUser(parsedUser);

        return;
      }

      if (storedAuthUser) {

        const parsedUser =
          JSON.parse(storedAuthUser);

        setUser(parsedUser);
      }

    } catch (error) {

      console.error(
        "Unable to load profile user:",
        error
      );

    }

  }, []);


  /* =========================================================
     PROFILE DROPDOWN
  ========================================================= */

  const toggleProfileDropdown = () => {

    setIsProfileDropdown(
      (previous) => !previous
    );

  };


  /* =========================================================
     USER DATA
  ========================================================= */

  const userName =
    user?.name ||
    user?.username ||
    "User";

  const userEmail =
    user?.email ||
    "";

  const userRole =
    user?.role ||
    "Staff";

    const normalizedRole = String(userRole).trim().toLowerCase();

const isStaffOrCounsellor = [
  "staff",
  "counsellor",
  "counselor",
].includes(normalizedRole);


  const getInitials = (name) => {

    return String(name || "User")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map(
        (part) =>
          part
            .charAt(0)
            .toUpperCase()
      )
      .join("");

  };


  /* =========================================================
     CHANGE PASSWORD MODAL
  ========================================================= */

  const openChangePasswordModal = () => {

    setIsProfileDropdown(false);

    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");

    setPasswordError("");
    setPasswordSuccess("");

    setIsPasswordModalOpen(true);
  };


  const closeChangePasswordModal = () => {

    if (isChangingPassword) {
      return;
    }

    setIsPasswordModalOpen(false);

    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");

    setPasswordError("");
    setPasswordSuccess("");
  };


  /* =========================================================
     CHANGE PASSWORD
  ========================================================= */

  const handleChangePassword = async (
    event
  ) => {

    event.preventDefault();

    setPasswordError("");
    setPasswordSuccess("");


    if (!currentPassword) {

      setPasswordError(
        "Please enter your current password."
      );

      return;
    }


    if (!newPassword) {

      setPasswordError(
        "Please enter your new password."
      );

      return;
    }


    if (newPassword.length < 8) {

      setPasswordError(
        "New password must be at least 8 characters."
      );

      return;
    }


    if (
      newPassword === currentPassword
    ) {

      setPasswordError(
        "New password must be different from your current password."
      );

      return;
    }


    if (
      newPassword !== confirmPassword
    ) {

      setPasswordError(
        "New password and confirm password do not match."
      );

      return;
    }


    const userId =
      user?._id ||
      user?.id;


    if (!userId) {

      setPasswordError(
        "Unable to identify the logged-in user."
      );

      return;
    }


    try {

      setIsChangingPassword(true);

      const response =
        await axios.put(
          `/users/${userId}/change-password`,
          {
            currentPassword,
            newPassword,
          }
        );


      if (
        !response?.data?.success
      ) {

        throw new Error(
          response?.data?.message ||
          "Unable to change password."
        );

      }


      const updatedUser = {
        ...user,
        forcePasswordChange: false,
      };

      setUser(updatedUser);

      localStorage.setItem(
        "user",
        JSON.stringify(updatedUser)
      );

      localStorage.setItem(
        "authUser",
        JSON.stringify(updatedUser)
      );

      sessionStorage.setItem(
        "authUser",
        JSON.stringify(updatedUser)
      );


      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

      setPasswordSuccess(
        "Password changed successfully."
      );

    } catch (error) {

      console.error(
        "Change password error:",
        error
      );

      setPasswordError(
        error?.response?.data?.message ||
        error?.message ||
        "Unable to change password. Please try again."
      );

    } finally {

      setIsChangingPassword(false);

    }

  };


  /* =========================================================
     LOGOUT
  ========================================================= */

  const handleLogout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("authUser");

    sessionStorage.removeItem(
      "authUser"
    );

    window.location.href =
      "/login";
  };


  /* =========================================================
     SETTINGS MENU
  ========================================================= */

  const settingsItems = [
    {
      label: "Organization",
      path: "/settings/organization",
      icon: FiSettings,
      iconClass: "profile-icon-blue",
    },
    {
      label: "Users & Roles",
      path: "/settings/users",
      icon: FiUsers,
      iconClass: "profile-icon-purple",
    },
    {
      label: "Lead Statuses",
      path: "/settings/statuses",
      icon: FiList,
      iconClass: "profile-icon-orange",
    },
    {
      label: "Public Lead Form",
      path: "/settings/public-leads",
      icon: FiFileText,
      iconClass: "profile-icon-green",
    },
    {
      label: "Audit Logs",
      path: "/settings/audit-logs",
      icon: FiActivity,
      iconClass: "profile-icon-pink",
    },
  ];


  return (
    <>
      <style>
        {`
          .profile-dropdown-menu {
            min-width: 330px !important;
            padding: 8px !important;
            border: 0 !important;
            border-radius: 14px !important;
            box-shadow:
              0 12px 35px rgba(15, 23, 42, 0.14),
              0 3px 10px rgba(15, 23, 42, 0.06) !important;
          }

          .profile-user-header {
            padding: 12px 10px 14px;
          }

          .profile-avatar-large {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            object-fit: cover;
            border: 3px solid #f1f5ff;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
          }

          .profile-initials {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background: linear-gradient(
              135deg,
              #eef2ff,
              #e0e7ff
            );
            color: #4f46e5;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            font-weight: 700;
            flex-shrink: 0;
            border: 3px solid #f5f7ff;
          }

          .profile-role-badge {
            display: inline-flex;
            align-items: center;
            padding: 4px 9px;
            border-radius: 20px;
            background: #eef2ff;
            color: #4f46e5;
            font-size: 11px;
            font-weight: 600;
          }

          .profile-section-title {
            padding: 8px 10px 5px;
            font-size: 10px;
            font-weight: 700;
            letter-spacing: .08em;
            color: #94a3b8;
            text-transform: uppercase;
          }

          .profile-menu-item {
            border-radius: 9px !important;
            margin: 2px 0 !important;
            padding: 9px 10px !important;
            transition: all .18s ease;
          }

          .profile-menu-item:hover {
            background: #f8fafc !important;
            transform: translateX(2px);
          }

          .profile-icon {
            width: 34px;
            height: 34px;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-right: 11px;
            flex-shrink: 0;
          }

          .profile-icon-blue {
            background: #eaf2ff;
            color: #3b82f6;
          }

          .profile-icon-purple {
            background: #f2eaff;
            color: #8b5cf6;
          }

          .profile-icon-orange {
            background: #fff3e6;
            color: #f59e0b;
          }

          .profile-icon-green {
            background: #e8f8f0;
            color: #10b981;
          }

          .profile-icon-pink {
            background: #fcecf4;
            color: #ec4899;
          }

          .profile-icon-cyan {
            background: #e7f8fb;
            color: #06b6d4;
          }

          .profile-icon-red {
            background: #fff0f0;
            color: #ef4444;
          }

          .profile-menu-label {
            font-size: 13px;
            font-weight: 500;
            color: #334155;
          }

          .profile-menu-description {
            font-size: 11px;
            color: #94a3b8;
            margin-top: 1px;
          }

          .profile-divider {
            margin: 7px 4px !important;
            border-top: 1px solid #f1f5f9 !important;
          }

          .profile-logout {
            color: #dc2626 !important;
          }

          .profile-logout:hover {
            background: #fff5f5 !important;
          }

          .profile-chevron {
            color: #cbd5e1;
            transition: transform .18s ease;
          }

          .profile-menu-item:hover .profile-chevron {
            transform: translateX(2px);
          }
        `}
      </style>


      {/* =====================================================
          PROFILE DROPDOWN
      ===================================================== */}

      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >

        {/* =====================================================
            PROFILE BUTTON
        ===================================================== */}

        <DropdownToggle
          tag="button"
          type="button"
          className="btn"
        >

          <span className="d-flex align-items-center">

            <img
              className="rounded-circle header-profile-user"
              src={
                user?.avatar ||
                avatar1
              }
              alt="Profile"
            />

            <span className="text-start ms-xl-2">

              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userName}
              </span>

              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {userRole}
              </span>

            </span>

          </span>

        </DropdownToggle>


        {/* =====================================================
            DROPDOWN
        ===================================================== */}

        <DropdownMenu
          end
          className="dropdown-menu-end profile-dropdown-menu"
        >

          {/* ===================================================
              USER HEADER
          =================================================== */}

          <div className="profile-user-header">

            <div className="d-flex align-items-center">

              {user?.avatar ? (
                <img
                  src={user.avatar}
                  alt="Profile"
                  className="profile-avatar-large"
                />
              ) : (
                <div className="profile-initials">
                  {getInitials(userName)}
                </div>
              )}

              <div className="ms-3 overflow-hidden">

                <h6
                  className="mb-1 text-truncate"
                  style={{
                    fontSize: 14,
                    fontWeight: 650,
                    color: "#1e293b",
                  }}
                >
                  {userName}
                </h6>

                <p
                  className="mb-2 text-muted text-truncate"
                  style={{
                    fontSize: 11,
                  }}
                >
                  {userEmail ||
                    "No email available"}
                </p>

                <span className="profile-role-badge">
                  {userRole}
                </span>

              </div>

            </div>

          </div>


          <DropdownItem divider className="profile-divider" />


          {/* ===================================================
              ACCOUNT
          =================================================== */}

          <div className="profile-section-title">
            Account
          </div>


          <DropdownItem
            tag={Link}
            to="/profile"
            className="profile-menu-item d-flex align-items-center"
          >

            <span className="profile-icon profile-icon-blue">
              <FiUser size={17} />
            </span>

            <span className="flex-grow-1">

              <span className="profile-menu-label d-block">
                My Profile
              </span>

              <span className="profile-menu-description d-block">
                View and manage your profile
              </span>

            </span>

            <FiChevronRight
              size={15}
              className="profile-chevron"
            />

          </DropdownItem>


          <DropdownItem
            onClick={
              openChangePasswordModal
            }
            className="profile-menu-item d-flex align-items-center"
          >

            <span className="profile-icon profile-icon-cyan">
              <FiLock size={17} />
            </span>

            <span className="flex-grow-1">

              <span className="profile-menu-label d-block">
                Change Password
              </span>

              <span className="profile-menu-description d-block">
                Update your account password
              </span>

            </span>

            <FiChevronRight
              size={15}
              className="profile-chevron"
            />

          </DropdownItem>


          {/* ===================================================
              SETTINGS
          =================================================== */}

        {!isStaffOrCounsellor && (
  <>
    <div className="profile-section-title mt-1">
      Settings
    </div>

    {settingsItems.map((item) => {
      const Icon = item.icon;

      return (
        <DropdownItem
          key={item.path}
          tag={Link}
          to={item.path}
          className="profile-menu-item d-flex align-items-center"
        >
          <span className={`profile-icon ${item.iconClass}`}>
            <Icon size={17} />
          </span>

          <span className="flex-grow-1">
            <span className="profile-menu-label d-block">
              {item.label}
            </span>
          </span>

          <FiChevronRight
            size={15}
            className="profile-chevron"
          />
        </DropdownItem>
      );
    })}
  </>
)}
          <DropdownItem
            divider
            className="profile-divider"
          />


          {/* ===================================================
              LOGOUT
          =================================================== */}

          <DropdownItem
            onClick={handleLogout}
            className="profile-menu-item profile-logout d-flex align-items-center"
          >

            <span className="profile-icon profile-icon-red">
              <FiLogOut size={17} />
            </span>

            <span className="flex-grow-1">

              <span className="profile-menu-label d-block profile-logout">
                Logout
              </span>

              <span className="profile-menu-description d-block">
                Sign out of your account
              </span>

            </span>

          </DropdownItem>

        </DropdownMenu>

      </Dropdown>


      {/* =======================================================
          CHANGE PASSWORD MODAL
      ======================================================= */}

      <Modal
        isOpen={isPasswordModalOpen}
        toggle={closeChangePasswordModal}
        centered
        backdrop="static"
      >

        <ModalHeader
          toggle={
            isChangingPassword
              ? undefined
              : closeChangePasswordModal
          }
        >

          <div className="d-flex align-items-center">

            <span
              className="profile-icon profile-icon-cyan"
              style={{
                width: 36,
                height: 36,
                marginRight: 10,
              }}
            >
              <FiLock size={18} />
            </span>

            <span>
              Change Password
            </span>

          </div>

        </ModalHeader>


        <Form
          onSubmit={
            handleChangePassword
          }
        >

          <ModalBody>

            {passwordError && (
              <Alert
                color="danger"
                className="mb-3"
              >
                {passwordError}
              </Alert>
            )}


            {passwordSuccess && (
              <Alert
                color="success"
                className="mb-3"
              >
                {passwordSuccess}
              </Alert>
            )}


            <FormGroup className="mb-3">

              <Label for="currentPassword">
                Current Password
              </Label>

              <div className="position-relative">

                <Input
                  id="currentPassword"
                  type={
                    showCurrentPassword
                      ? "text"
                      : "password"
                  }
                  value={
                    currentPassword
                  }
                  onChange={(event) =>
                    setCurrentPassword(
                      event.target.value
                    )
                  }
                  placeholder="Enter current password"
                  autoComplete="current-password"
                  disabled={
                    isChangingPassword
                  }
                  className="pe-5"
                />

                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none"
                  onClick={() =>
                    setShowCurrentPassword(
                      (previous) =>
                        !previous
                    )
                  }
                  tabIndex={-1}
                  aria-label={
                    showCurrentPassword
                      ? "Hide current password"
                      : "Show current password"
                  }
                >
                  {showCurrentPassword ? (
                    <FiEyeOff size={17} />
                  ) : (
                    <FiEye size={17} />
                  )}
                </button>

              </div>

            </FormGroup>


            <FormGroup className="mb-3">

              <Label for="newPassword">
                New Password
              </Label>

              <div className="position-relative">

                <Input
                  id="newPassword"
                  type={
                    showNewPassword
                      ? "text"
                      : "password"
                  }
                  value={
                    newPassword
                  }
                  onChange={(event) =>
                    setNewPassword(
                      event.target.value
                    )
                  }
                  placeholder="Enter new password"
                  autoComplete="new-password"
                  disabled={
                    isChangingPassword
                  }
                  className="pe-5"
                />

                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none"
                  onClick={() =>
                    setShowNewPassword(
                      (previous) =>
                        !previous
                    )
                  }
                  tabIndex={-1}
                  aria-label={
                    showNewPassword
                      ? "Hide new password"
                      : "Show new password"
                  }
                >
                  {showNewPassword ? (
                    <FiEyeOff size={17} />
                  ) : (
                    <FiEye size={17} />
                  )}
                </button>

              </div>

              <small className="text-muted">
                Minimum 8 characters.
              </small>

            </FormGroup>


            <FormGroup className="mb-0">

              <Label for="confirmPassword">
                Confirm New Password
              </Label>

              <div className="position-relative">

                <Input
                  id="confirmPassword"
                  type={
                    showConfirmPassword
                      ? "text"
                      : "password"
                  }
                  value={
                    confirmPassword
                  }
                  onChange={(event) =>
                    setConfirmPassword(
                      event.target.value
                    )
                  }
                  placeholder="Confirm new password"
                  autoComplete="new-password"
                  disabled={
                    isChangingPassword
                  }
                  className="pe-5"
                />

                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none"
                  onClick={() =>
                    setShowConfirmPassword(
                      (previous) =>
                        !previous
                    )
                  }
                  tabIndex={-1}
                  aria-label={
                    showConfirmPassword
                      ? "Hide confirm password"
                      : "Show confirm password"
                  }
                >
                  {showConfirmPassword ? (
                    <FiEyeOff size={17} />
                  ) : (
                    <FiEye size={17} />
                  )}
                </button>

              </div>

            </FormGroup>

          </ModalBody>


          <ModalFooter>

            <Button
              type="button"
              color="light"
              onClick={
                closeChangePasswordModal
              }
              disabled={
                isChangingPassword
              }
            >
              Cancel
            </Button>

            <Button
              type="submit"
              color="primary"
              disabled={
                isChangingPassword
              }
            >

              {isChangingPassword ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />

                  Changing...

                </>
              ) : (
                "Change Password"
              )}

            </Button>

          </ModalFooter>

        </Form>

      </Modal>
    </>
  );
};


export default ProfileDropdown;